<div class="container-fluid p-0 sticky-top">
  <div id="loader" *ngIf="enableLoader"></div>
  <div *ngIf="!enableLoader">

    <!-- Back nav -->
    <div class="mb-0 py-3 border-bottomn s-back" >
      <div class="container">
        <a class="strong text-primary cursor-pointer" (click)="backToList()">
          &lt; {{ 'home.quote.Backtolist' | cxTranslate }}
        </a>
      </div>
    </div>

    <!-- Header section -->
    <div class="mb-0 py-4 border-bottom s-back" >
      <div class="container">
        <div class="row d-flex justify-content-between">
          <!-- Status badge -->
          <div class="col-md-2 col-lg-2 pl-0">
            <h6 class="pt-2 pb-2 col">
              <span class="badge badge-set"
                [ngClass]="{
                  'badge-inprogress': details?.status === 'INPROGRESS',
                  'badge-blue':    details?.status === 'NEW',
                  'badge-success':    details?.status === 'ASSIGNED',
                  'badge-black badge-set-black': details?.status === 'COMPLETED'
                }">
                {{ details?.statusLocale }}
              </span>
            </h6>
          </div>

          <!-- Quality completed toggle -->
          <div class="d-none d-md-block d-lg-block col-lg-6">
            <div class="move-right">
            <p class="small strong text-secondary mb-2"> {{  'quality.qualityCompleted' | cxTranslate }}</p>
            <div class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons" style="width:120px">
              <label class="btn m-0 border1 text-secondary pd-tp-bt"
                [ngClass]="qualityCompleted === true ? 'active_yes' : 'deactive'"
                [class.disabled]="details?.status === 'COMPLETED'"
                (click)="setQualityCompleted(true)">
                <input type="radio" name="qualityCompleted" id="qualityYes"> <p class="pt-2 fw-bold">{{'batches.YES' | cxTranslate}}</p>
              </label>
              <label class="btn m-0 border1 pd-tp-bt"
                [ngClass]="qualityCompleted === false ? 'active_no' : 'deactive'"
                [class.disabled]="details?.status === 'COMPLETED'"
                (click)="setQualityCompleted(false)">
                <input type="radio" name="qualityCompleted" id="qualityNo"> <p class="pt-2 fw-bold">{{'batches.NO' | cxTranslate}}</p>
              </label>
            </div>
            </div>
          </div>
          <div class="d-none d-md-block d-lg-block col-lg-2 text-right">
          <button type="button" class="btn btn-secondarybtn d-none d-sm-block mx-2" (click)="donwloadReport('quality_report')">
          <img src="./images/download_report.svg" alt="export" width="20px" height="20px">
          &nbsp; Export
        </button>
          </div>
           <div class="col-md-2">
                        <div *ngIf="(details?.status == 'COMPLETED')" class="justify-content-end">
                        <button *ngIf="isAgentInvoiceActive === 'true'"
                            class="btn btn-sm strong btn-primary border rounded btnheight pl-5 pr-5"
                            (click)="openInvoices(details)">{{'shipment.invoice.attachInvoice' |
                            cxTranslate}}</button>
                    </div>
                </div>
        </div>

        <!-- Batch ID and vessel name -->
        <div class="mt-1">
          <h2 class="h4 bold">{{ details?.batchId }}</h2>
          <h2 class="h4 mb-4 text-secondary">{{ details?.vesselName }}</h2>
        </div>

        <!-- Info row -->
        <div class="row d-flex ml-0 mr-0">
         <div class="col-md-4 col-lg-4">
          <div class="row d-flex">
             <div class="col-sm-4 d-none d-md-block d-lg-block col-md-6 col-lg-6 pl-0">
            <p class="small strong text-secondary mb-2">{{  'batches.Dischargeport' | cxTranslate }}</p>
            <h4 class="h4 bold">{{ details?.port || '--' }}</h4>
          </div>
          <div class="col-sm-4 d-none d-md-block d-lg-block col-md-6 col-lg-6 pl-0">
            <p class="small strong text-secondary mb-2">{{  'quality.totalInspectedQty' | cxTranslate }}</p>
            <h4 class="h4 bold">{{ details?.formattedTotalInspectedQty || '0' }}</h4>
          </div>
          </div>
         </div>
          <div class="col-sm-4 d-none d-md-block d-lg-block col-md-1 col-lg-1 pl-0">
            <p class="small strong text-secondary mb-2">NBSL (Fe)</p>
            <h4 class="h4 bold">{{ details?.formattedLumpFe || '0' }}</h4>
          </div>
          <div class="col-sm-4 d-none d-md-block d-lg-block col-md-1 col-lg-1 pl-0">
            <p class="small strong text-secondary mb-2">NBSL (H2O)</p>
            <h4 class="h4 bold">{{ details?.formattedLumpH2o || '0' }}</h4>
          </div>
          <div class="col-sm-4 d-none d-md-block d-lg-block col-md-1 col-lg-1 pl-0">
            <p class="small strong text-secondary mb-2">NBSL (-6.3mm)</p>
            <h4 class="h4 bold">{{ details?.formattedLumpMinus6p3Mm || '0' }}</h4>
          </div>
          <div class="col-sm-4 d-none d-md-block d-lg-block col-md-1 col-lg-1 pl-0">
            <p class="small strong text-secondary mb-2">NBSF (Fe)</p>
            <h4 class="h4 bold">{{ details?.formattedFineFe || '0' }}</h4>
          </div>
          <div class="col-sm-4 d-none d-md-block d-lg-block col-md-1 col-lg-1 pl-0">
            <p class="small strong text-secondary mb-2">NBSF (H2O)</p>
            <h4 class="h4 bold">{{ details?.formattedFineH2o || '0' }}</h4>
          </div>
          <div class="col-md-3 col-lg-3">
            <div class="row d-flex">
              <div class="col-sm-4 d-none d-md-block d-lg-block col-md-5 col-lg-5 pl-0">
                <p class="small strong text-secondary mb-2">NBSF (+6.3mm)</p>
                <h4 class="h4 bold">{{ details?.formattedFinePlus6p3Mm || '0' }}</h4>
              </div>
              <!-- <div class="col-sm-4 d-none d-md-block d-lg-block col-md-7 col-lg-7 pl-0">
                <p class="small strong text-secondary mb-2">Quality agent</p>
                <h4 class="h4 bold">{{ details?.agent || '0' }}</h4>
              </div> -->
            </div>
          </div>
        </div>

         <!-- Instructions section -->
    <div class="mt-4">
      <div class="d-flex justify-content-between align-items-start">
        <div class="flex-grow-1">
          <div class="d-flex align-items-center mb-2">
            <h5 class="bold text-secondary mb-0 mr-2">{{  'quality.instructions' | cxTranslate }}</h5>           
          </div>
          <p class="text-secondary mb-0">{{ details?.instruction || '--' }}</p>
        </div>
      </div>
    </div>
      </div>
    </div>

    <!-- Attachments bar -->
    <div class="container py-3">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h5 class="small bold text-secondary mb-1">
            {{  'batches.attatchments' | cxTranslate }} ({{ attachments?.length || 0 }})
          </h5>
          <span class="text-secondary small" *ngIf="!attachments?.length">
            {{  'quality.noFilesAttachedShip' | cxTranslate }}
          </span>
          <span *ngFor="let file of attachments">
            <i class="fas fa-file-alt text-primary mr-1"></i>
            <a target="_blank" class="small font-weight-bold text-primary" href="{{ file.publicUrl }}">
              {{ file.name || file.description }}
            </a>&nbsp;
          </span>
        </div>
        <button class="btn btn-save" [disabled]="analysisForm.invalid" *ngIf="!showEditButton" (click)="save()">{{  'batches.save' | cxTranslate }}</button>
        <button [class.disabled]="details?.status === 'COMPLETED'" class="btn btn-secondary" *ngIf="showEditButton" (click)="edit()">{{  'batches.edit' | cxTranslate }}</button>
      </div>
    </div>

    <!-- Main content: lots panel + analysis form -->
    <div class="container px-2.5 pb-5">
      <div class="row">

        <!-- Left: Lot list -->
        <div class="col-md-3 col-lg-3 pr-2">

          <!-- Lot items -->
          <div *ngFor="let lot of lots; let i = index"
            class="lot-card mb-2"
            [ngClass]="{ 'lot-card--active': selectedLotIndex === i }">
            <div class="d-flex justify-content-between align-items-center" (click)="selectLot(i)">
              <div class="flex-grow-1">
                <div class="lot-card__title ">{{'quality.lot' | cxTranslate}} {{ i + 1 }}</div>
                <div class="lot-card__subtitle text-secondary small">
                  {{ lot.hasEntry ? '' : ('quality.newEntryRegisteredyet' | cxTranslate) }}
                </div>
                <div *ngIf="lot.lotFormData.createdOn" class="text-secondary">{{  'quality.lastEntryOn' | cxTranslate }} {{ lot.lotFormData.createdOn }}</div>
                <div>
                  <ng-container *ngFor="let file of lot.lotFormData.documents">
                   
                    <span *ngIf="file?.publicUrl">
                      <i class="fas fa-file-alt text-primary mr-1"></i>
                      <a target="_blank" class="small font-weight-bold text-primary" href="{{ file.publicUrl }}">
                        {{ file.description }}
                      </a>&nbsp;
                    </span>
                  </ng-container>
                </div>
              </div>
              <!-- <button class="btn btn-sm lot-card__delete-btn" 
                (click)="deleteLot(i); $event.stopPropagation()" 
                
                title="Delete lot">
                <i class="fas fa-trash-alt"></i>
              </button> -->
            </div>
          </div>

          <!-- Add new lot -->
          <div class="lot-card lot-card--add d-flex justify-content-between align-items-center" 
            [class.disabled]="details?.status === 'COMPLETED'"
            (click)="addLot()">
            <div>
              <div class="lot-card__title text-secondary">{{  'quality.addNewLot' | cxTranslate }}</div>
              <div class="lot-card__subtitle text-secondary small">{{  'quality.registerNewEntry' | cxTranslate }}</div>
            </div>
            <span class="lot-card__plus">+</span>
          </div>

        </div>

        <!-- Right: Analysis form -->
        <div class="col-md-9 col-lg-9 pl-2" *ngIf="lots?.length">
          <div class="analysis-card">

            <!-- Card header -->
            <div class="d-flex justify-content-between align-items-center analysis-card__header">
              <h6 class="mb-0 bold">{{  'quality.lot' | cxTranslate }} {{ selectedLotIndex + 1 }} - {{ analysisType === 'NBSL' ? ('quality.NBSLanalysis' | cxTranslate) : ('quality.NBSFanalysis' | cxTranslate) }}</h6>
              <div class="btn-group btn-group-sm">
                <button class="btn analysis-toggle b-radius"
                  [ngClass]="analysisType === 'NBSL' ? 'analysis-toggle--active' : 'analysis-toggle--inactive'"
                  (click)="setAnalysisType('NBSL')">NBSL</button>
                <button class="btn analysis-toggle b-radius"
                  [ngClass]="analysisType === 'NBSF' ? 'analysis-toggle--active' : 'analysis-toggle--inactive'"
                  (click)="setAnalysisType('NBSF')">NBSF</button>
              </div>
            </div>

            <div class="analysis-card__body">
              <form [formGroup]="analysisForm">

                <!-- Row 1: Dates -->
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label class="text-secondary">{{  'quality.reportingDate' | cxTranslate }} <span class="text-danger">*</span></label>
                    <div class="input-group input-group-sm apply-border" *ngIf="!showEditButton">
                      <input class="form-control remove-border"
                        [ngClass]="{ 'is-invalid': isFieldInvalid('reportingDate') }"
                        placeholder="DD/MM/YYYY"
                        name="reportingDate"
                        ngbDatepicker
                        #d="ngbDatepicker"
                        formControlName="reportingDate"
                        id="reportingDate"
                        required
                        (click)="d.toggle()"
                        (dateSelect)="onDateSelect($event)" />
                        <i class="far pickup-calendar padding-5" (click)="d.toggle()" ><img src="/images/calendar.svg"   alt="customlogo" width="18px" height="18px" class="" ></i>
                    </div>
                    
                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('reportingDate')">
                      {{  'quality.reportingDateRequired' | cxTranslate }} {{  'quality.reportingDateRequired' | cxTranslate }}
                    </div>
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.reportingDate || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">{{  'quality.startDate' | cxTranslate }} <span class="text-danger">*</span></label>
                    <div class="input-group input-group-sm apply-border" *ngIf="!showEditButton">
                      <input class="form-control remove-border"
                        placeholder="DD/MM/YYYY"
                        name="startDate"
                        ngbDatepicker
                        #e="ngbDatepicker"
                        formControlName="startDate"
                        id="startDate"
                        required
                        [ngClass]="{ 'is-invalid': isFieldInvalid('startDate') }"
                        (click)="e.toggle()"
                        (dateSelect)="onStartDateSelect($event)" />
                        <i class="far pickup-calendar padding-5" (click)="e.toggle()" ><img src="/images/calendar.svg"   alt="customlogo" width="18px" height="18px" class="" ></i>
                    </div>
                     <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('startDate')">
                      {{'quality.startDateRequired' | cxTranslate}}
                    </div>
                     <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.startDate || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">{{  'quality.endDate' | cxTranslate }} <span class="text-danger">*</span></label>
                    <div class="input-group input-group-sm apply-border" *ngIf="!showEditButton">
                      <!--  -->
                     <input class="form-control remove-border"  [ngClass]="{ 'is-invalid': hasFormError('invalidDateRange') }"                    
                      placeholder="DD/MM/YYYY"
                      name="endDate"
                      ngbDatepicker
                      #f="ngbDatepicker"
                      formControlName="endDate"
                      id="endDate"
                      required
                      [ngClass]="{ 'is-invalid': isFieldInvalid('endDate') }"
                      (click)="f.toggle()"
                      (dateSelect)="onEndDateSelect($event)" />
                      <i class="far pickup-calendar padding-5" (click)="f.toggle()" ><img src="/images/calendar.svg"   alt="customlogo" width="18px" height="18px" class="" ></i>
                    </div>
                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('endDate')">
                     {{'quality.endDateRequired' | cxTranslate}}
                    </div>
                    <div class="invalid-feedback d-block" *ngIf="hasFormError('invalidDateRange')">
                      {{'quality.invalidDateRange' | cxTranslate}}
                    </div>
                     <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.endDate || '--'}}</p>
                  </div>
                  <div class="col-md-3"  *ngIf="showEditButton">
                    <label class="text-secondary">{{  'quality.totalLotQuantity' | cxTranslate }}</label>                    
                     <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.formattedTotalLotQty || '--'}}</p>
                  </div>
                </div>

                <!-- Row 2: NBSL quantity, Fe, SiO2, Al2O3 -->
                <div class="row mb-2" *ngIf="analysisType === 'NBSL'">
                  <div class="col-md-3">
                    <label class="text-secondary">{{  'quality.NBSLquantity' | cxTranslate }} <span class="text-danger">*</span></label>
                    <input type="text"  appPositiveNegativeDecimalNumber
                    [beforeDecimal]="8" [afterDecimal]="2" [numberType]="'positive'"class="form-control form-control-sm" formControlName="nbslQuantity" 
                    *ngIf="!showEditButton" required [ngClass]="{ 'is-invalid': isFieldInvalid('nbslQuantity') }" >
                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('nbslQuantity')">
                      {{'quality.nbslQuantityRequired' | cxTranslate}}
                    </div>                                  
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.quantity || '--'}}</p>
                  </div>                   
                  <div class="col-md-3">
                    <label class="text-secondary">Fe</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslTotalFe"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.totalFe || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">SiO2</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslSilica"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.silica || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">Al2O3</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslAlumina"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.alumina || '--'}}</p>
                  </div>
                </div>

                <div class="row mb-2" *ngIf="analysisType === 'NBSF'">
                  <div class="col-md-3" >
                    <label class="text-secondary">{{  'quality.NBSFquantity' | cxTranslate }} <span class="text-danger">*</span></label>
                    <input type="text"  appPositiveNegativeDecimalNumber
                    [beforeDecimal]="8" [afterDecimal]="2" [numberType]="'positive'"class="form-control form-control-sm" formControlName="nbsfQuantity" 
                    *ngIf="!showEditButton" required [ngClass]="{ 'is-invalid': isFieldInvalid('nbsfQuantity') }" >
                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('nbsfQuantity')">
                       {{'quality.nbsfQuantityRequired' | cxTranslate}}
                    </div>
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.quantity || '--'}}</p>
                  </div>
                   <div class="col-md-3">
                    <label class="text-secondary">Fe</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfTotalFe"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.totalFe || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">SiO2</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfSilica"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.silica || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">Al2O3</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfAlumina"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.alumina || '--'}}</p>
                  </div>
                </div>

                <!-- Row 3: F, S, LOI, H2O -->
                <div class="row mb-2" *ngIf="analysisType === 'NBSL'">
                  <div class="col-md-3">
                    <label class="text-secondary">P</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslPhosphorus"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="3" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.phosphorus || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">S</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslSulfur"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="3" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.sulfur || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">L.O.I</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslLossOnIgnition"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.lossOnIgnition || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">H2O</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbslMoistureContent"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.moistureContent || '--'}}</p>
                  </div>
                </div>

                 <div class="row mb-2" *ngIf="analysisType === 'NBSF'">
                  <div class="col-md-3">
                    <label class="text-secondary">P</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfPhosphorus" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="3" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.phosphorus || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">S</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfSulfur" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="3" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.sulfur || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">L.O.I</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfLossOnIgnition"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.lossOnIgnition || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">H2O</label>
                    <input type="text" class="form-control form-control-sm" formControlName="nbsfMoistureContent"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="2" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.moistureContent || '--'}}</p>
                  </div>
                </div>

                <!-- Row 4: +31.5mm, +25.0mm, +20.0mm, -6.3mm -->
                <div class="row mb-2" *ngIf="analysisType === 'NBSL'">
                  <div class="col-md-3">
                    <label class="text-secondary">+31.5mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize31p5Mm"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize31p5Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+25.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize25Mm"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize25Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+20.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize20Mm"  appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize20Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+15.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize15Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize15Mm || '--'}}</p>
                  </div>
                </div>

                <!-- Row 5: +15.0mm, +10.0mm, +8.0mm, +6.2mm -->
                <div class="row mb-3" *ngIf="analysisType === 'NBSL'">
                  
                  <div class="col-md-3">
                    <label class="text-secondary">+10.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize10Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize10Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+8.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize8Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize8Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+6.3mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize6p3Mm_nbsl" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.oversize6p3Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">-6.3mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="undersize6p3Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.lumpQuality?.undersize6p3Mm || '--'}}</p>
                  </div>
                </div>

                <div class="row mb-2" *ngIf="analysisType === 'NBSF'">
                  <div class="col-md-3">
                    <label class="text-secondary">+6.3mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize6p3Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.oversize6p3Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+4.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize4Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.oversize4Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+1.0mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize1Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.oversize1Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+0.5mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize0p5Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.oversize0p5Mm || '--'}}</p>
                  </div>
                </div>
                <div class="row mb-3" *ngIf="analysisType === 'NBSF'">
                  <div class="col-md-3">
                    <label class="text-secondary">+0.25mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize0p25Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.oversize0p25Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">+0.15mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="oversize0p15Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.oversize0p15Mm || '--'}}</p>
                  </div>
                  <div class="col-md-3">
                    <label class="text-secondary">-0.15mm</label>
                    <input type="text" class="form-control form-control-sm" formControlName="minus0p15Mm" appTwoDigitDecimaNumber [beforeDecimal]="3" [afterDecimal]="1" *ngIf="!showEditButton">
                    <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.fineQuality?.minus0p15Mm || '--'}}</p>
                  </div>
                </div>
                <!-- General remarks -->
                <div class="mb-3">
                  <label class="text-secondary">{{  'quality.generalRemarks' | cxTranslate }}</label>
                  <textarea class="form-control" rows="3" formControlName="remarks" *ngIf="!showEditButton"></textarea>
                  <p *ngIf="showEditButton" class="strong text-black"> {{currentLotData?.remarks || '--'}}</p>
                </div>

                <!-- File upload -->
                <div *ngIf="!showEditButton" class="upload-area mb-3"
                  (dragover)="onDragOver($event)"
                  (drop)="onDropSuccess($event)">
                  <div class="upload-area__inner d-flex align-items-center justify-content-between px-4 py-4 w-75 ml-auto mr-auto">
                    <div class="d-flex align-items-center upload-area__content">
                      <img src="/images/upload-img.svg" alt="Upload" class="upload-area__icon mr-4">
                      <!-- <i class="fas fa-cloud-upload-alt upload-icon mr-4" aria-hidden="true"></i> -->
                      <div>
                        <div class="upload-area__title">{{ 'quality.selectFileorDragHere' | cxTranslate }}</div>
                        <div class="upload-area__subtitle">{{ 'quality.fileSizeLimit' | cxTranslate }}</div>
                      </div>
                    </div>
                    <button type="button" class="btn btn-select-file" (click)="fileInput.click()">
                      {{ 'quality.selectFile' | cxTranslate }}
                    </button>
                    <input #fileInput type="file" hidden (change)="onFileChange($event.target.files)">
                  </div>                 
                </div>              
                <p *ngIf="showEditButton && fileArray?.length !== 0" class="text-black strong">{{ 'quality.attachedDocuments' | cxTranslate }}</p>
                   <div id="loader" *ngIf="fileLoading"></div>
                   <div *ngIf="!fileLoading">
                    <div  *ngIf="fileArray?.length" class=" pb-3">
                    <div class="filesection mt-2"  *ngFor="let file of fileArray;let i=index;" >
                      <div class="d-flex">
                        <div class="d-flex align-items-center w-100 m-2">
                          <div><img src="/images/file-alt.svg" class="p-2"></div>
                          <div class="w-100">
                             <p class="file_name">{{file.name || file.description}} </p> <!--<span><a *ngIf="file.downloadUrl!=undefined" class="pt-2 btn btn-sm text-primary shadow-none small m-height" href="{{file.downloadUrl}}">Preview</a></span></p> -->
                            <p class="file_size text-secondary">{{file.size / 1024 / 1024 | number: '.3'}}MB / {{file.size / 1024 / 1024 | number: '.3'}}MB</p> 
                          </div>
                        </div>   
                        <button *ngIf="!showEditButton" type="button"class="close p-2" aria-label="Close" (click)="removeUploadedAttachment(i)">
                          <span aria-hidden="true">&times;</span>
                        </button>               
                      </div>
                  </div>
                  </div>
                   </div>
                 
               <div *ngIf="showEditButton" class="mt-2"> 
                  <span class="text-secondary ">{{  'quality.entryDate' | cxTranslate }}: {{currentLotData.createdOn}} &nbsp; {{  'quality.lastUpdatedOn' | cxTranslate }}: {{currentLotData.modifiedOn}} &nbsp;  {{  'quality.lastUpdatedBy' | cxTranslate }}: {{currentLotData.updatedBy}}</span>
               </div>

              </form>
            </div>
          </div>
        </div>

      </div>
    </div>

  

  </div>
</div>
